module.exports = "/lucky-balls/img/bonus_green/check_infoBar/check_008.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/check_infoBar/check_008.png
// module id = 931
// module chunks = 0